$(document).ready(function () {
  $(".pp_ro-testimonials-slider").slick({
    infinite: false,
    slidesToShow: 3.2,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    prevArrow: $(".pp_ro-testimonials-arrow--prev"),
    nextArrow: $(".pp_ro-testimonials-arrow--next"),
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1.3,
        },
      },
    ],
  });
});
